export const getGeolocation = (): Promise<string | undefined> => {
  return new Promise((resolve, reject) => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve(`${latitude},${longitude}`);
        },
        (error) => {
          console.error('Error getting geolocation:', error);
          resolve(undefined); // Return null when an error occurs
        }
      );
    } else {
      console.error('Geolocation is not available in this browser.');
      resolve(undefined); // Return null when geolocation is not available
    }
  });
};